import { createFileRoute } from '@tanstack/react-router';
import { generateValidateSearch } from '@/lib/filters/validate-search';
import { peopleFilterConfig } from '@/lib/filters/configs/people-filters';

/**
 * People directory — re-added after ENT-89 retired it in favour of Workforce-only browsing.
 * Person *detail* (`/people/$personId`) and Add Person (`/people/new`) were never gated by the
 * old redirect and stay untouched — this only restores the listing itself.
 *
 * The schema comes from the same config the page renders from, so a param the route does not
 * declare is stripped on the next navigation and the two cannot drift.
 */
export const Route = createFileRoute('/people/')({
  validateSearch: generateValidateSearch(peopleFilterConfig),
});
